var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWork(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "512.000000pt",
    height: "512.000000pt",
    viewBox: "0 0 512.000000 512.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,512.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2015 4676 c-119 -38 -208 -114 -262 -224 l-38 -76 -5 -160 -5 -161 -620 -5 c-608 -5 -621 -5 -685 -27 -131 -45 -270 -164 -329 -281 -65 -130 -66 -139 -66 -466 l0 -299 1278 -426 1277 -426 1278 426 1277 426 0 299 c0 267 -2 305 -19 354 -33 97 -74 167 -136 234 -71 75 -135 119 -228 155 l-67 26 -625 5 -625 5 -5 161 -5 160 -37 75 c-46 93 -112 158 -206 202 l-67 32 -520 2 c-401 2 -529 -1 -560 -11z m970 -516 l0 -105 -425 0 -425 0 -3 94 c-1 52 0 101 2 108 5 11 83 13 428 11 l423 -3 0 -105z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 1769 c3 -862 3 -875 24 -929 42 -109 77 -166 148 -236 84 -83 154 -125 256 -153 74 -21 82 -21 2130 -21 2264 0 2103 -4 2240 62 44 21 89 55 141 107 76 75 111 130 153 241 21 54 21 67 24 929 2 707 0 872 -10 869 -7 -3 -564 -189 -1238 -413 l-1225 -409 -85 0 -85 0 -1225 409 c-674 224 -1231 410 -1238 413 -10 3 -12 -162 -10 -869z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWork);
export default __webpack_public_path__ + "static/media/work.61db91d64ba0bd93c678dd78e9a157c5.svg";
export { ForwardRef as ReactComponent };